import styled from 'styled-components'

export const Icon = styled.button`
    position: fixed;
    width: 64px;
    height: 64px;
    bottom: 25px;
    right: 25px
`

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Content = styled.div`
    text-align: center;
`

export const Title = styled.div`
    text-align: center;
    margin-bottom: 50px;
    font-size: 24px;
    font-weight: bold;
`

export const Link = styled.a`
    text-align: center;
    padding: 20px 50px 20px 50px;
    font-size: 14px;
    color: #fff;
    background-color: #5ed169;
    border-radius: 6px;
    cursor: pointer;
`

export const Text = styled.div`
    text-align: center;
    margin-bottom: 10px;
    margin-top: 50px;
    font-size: 14px;
`

export const QR = styled.img`
    width: 152px;
    height: 152px;
`
